<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
      class="member-name"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.proposal.publishByMultipleApproved.p1')}}
    <a href="#">
      {{news.textParams[8]}}
      {{$t('news.template.proposal.publishByMultipleApproved.p2')}}
    </a>
    {{$t('news.template.proposal.publishByMultipleApproved.p3')}}
    <router-link
      :to="{name: 'ProposalView', params: {id: news.textParams[3]}}"
    >{{news.textParams[4]}}</router-link>
    {{$t('news.template.proposal.publishByMultipleApproved.p4')}}
    <router-link :to="{name: 'forum', params: {id: news.textParams[5]}}"
    >{{news.textParams[6]}}</router-link>.
    <router-link :to="{name: 'forum', params: {id: news.textParams[5]}}"
    >{{news.textParams[6]}}</router-link>
    {{$t('news.template.proposal.publishByMultipleApproved.p5')}}
    {{news.textParams[2]}}
    {{$t('news.template.proposal.publishByMultipleApproved.p6')}}
    {{news.textParams[7]}}
    <router-link :to="{name: 'ProposalView', params: {id: news.textParams[3]}}">
      {{$t('news.template.proposal.publishByMultipleApproved.p7')}}
    </router-link>
    {{$t('news.template.proposal.publishByMultipleApproved.p8')}}
  </div>
</template>
